// extracted by mini-css-extract-plugin
export default {"statistic-header":"style_statistic-header__20lbp"};